











import ProductReviewCard from '@/web/components/products/ProductReviewCard.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'CustomerProductReviewModal',
  components: {
    ProductReviewCard,
  },
  props: {
    review: {
      type: Object as () => ProductReviewResponse,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
    }),
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
